
import {
    FETCH_CONTACTS_ERROR,
    FETCH_CONTACTS_LOADING,
    FETCH_CONTACTS_SUCCESS,

    RESET_CONTACTS,
    FETCH_MORE_CONTACTS_SUCCESS
} from "../action/index" 

const defaultState= {
    data: [],
    error: null,
    isLoading: false,
    meta: [],
}

const contactReducer = (state = defaultState, action ) => {
    let dupState = {...state}
    switch(action.type){
        case FETCH_CONTACTS_SUCCESS:
            return {...state, data: action.payload, isLoading: false, error: null, meta: action.meta}
        case FETCH_CONTACTS_LOADING:
            return {...state, isLoading: true, error: null}
        case FETCH_CONTACTS_ERROR:
            return {...state, isLoading: false, error: "FETCH_CONTACTS_ERROR"}
        case RESET_CONTACTS:
            return {...state, data: [], isLoading: true, meta: []}
        case FETCH_MORE_CONTACTS_SUCCESS:
            return {...state, data: dupState.data.concat( action.payload ), isLoading: false, error: null, meta: action.meta}
        default:
            return {...state};
    }
}

export default contactReducer;